// Načtení Leaflet z CDN
const L = window.L;

// Vlastní ikona v liberecké červené
const liberecRedIcon = L.divIcon({
  className: 'custom-div-icon',
  html: `<div style="
    background-color: #db453a;
    width: 25px;
    height: 25px;
    border-radius: 50%;
    border: 3px solid white;
    box-shadow: 0 2px 4px rgba(0,0,0,0.3);
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-weight: bold;
    font-size: 12px;
  ">📍</div>`,
  iconSize: [25, 25],
  iconAnchor: [12, 12]
});

function initializeMap() {
  const mapElement = document.getElementById('places-map');
  if (!mapElement) return;

  // Zničení existující mapy pokud existuje
  if (window.placesMap) {
    window.placesMap.remove();
  }

  // Inicializace mapy - centrum na Liberec
  const map = L.map('places-map').setView([50.7671, 15.0564], 13);
  
  map.scrollWheelZoom.disable();

  map.on('click', function() {
    map.scrollWheelZoom.enable();
  });

  map.on('mouseout', function() {
    map.scrollWheelZoom.disable();
  });
  
  // Uložení reference pro pozdější zničení
  window.placesMap = map;

  // CARTO voyager (s platným API klíčem), jinak OpenStreetMap fallback
  const cartoApiKey = mapElement.dataset.cartoApiKey;
  if (cartoApiKey) {
    L.tileLayer('https://basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png?key=' + encodeURIComponent(cartoApiKey), {
      attribution: '© OpenStreetMap contributors, © CARTO',
      maxZoom: 20
    }).addTo(map);
  } else {
    L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '© OpenStreetMap contributors',
      maxZoom: 19
    }).addTo(map);
  }

  // Načtení dat o místech z data atributu
  const placesData = JSON.parse(mapElement.dataset.places || '[]');
  
  // Přidání markerů pro každé místo
  placesData.forEach(place => {
    if (place.latitude && place.longitude) {
      const marker = L.marker([place.latitude, place.longitude], { icon: liberecRedIcon })
        .addTo(map)
        .bindTooltip(place.name, {
          permanent: false,
          direction: 'top',
          offset: [0, -10]
        })
        .bindPopup(`
          <div class="map-popup-card">
            <a href="${place.url}" class="map-popup-link">
              ${place.cover_image_url ? `<div class="map-popup-image" style="background-image: url('${place.cover_image_url}')"></div>` : ''}
              <div class="map-popup-content">
                <h3 class="map-popup-title">${place.name}</h3>
                ${place.address ? `<p class="map-popup-address">${place.address}</p>` : ''}
                ${place.description ? `<p class="map-popup-description">${place.description}</p>` : ''}
              </div>
            </a>
          </div>
        `, {
          className: 'custom-leaflet-popup'
        });
    }
  });

  // Fit map na všechny markery
  if (placesData.length > 0) {
    const group = new L.featureGroup();
    placesData.forEach(place => {
      if (place.latitude && place.longitude) {
        group.addLayer(L.marker([place.latitude, place.longitude]));
      }
    });
    if (group.getLayers().length > 0) {
      map.fitBounds(group.getBounds().pad(0.1));
    }
  }
}

// Inicializace při Turbo navigaci (funguje i při první návštěvě)
document.addEventListener('turbo:load', initializeMap);
